import React from 'react'
import Modal from 'react-responsive-modal'
import styles from './styles.module.css'
import cn from 'classnames'
import { MdOutlineError } from "react-icons/md";

export default function ModalComponent({
    children = [],
    menuList = [],
    menuItem = '',
    setMenuItem = () => { },
    disabledItems = [],
    compact = false,
    ...props
}) {

    const renderLi = (item) => {
        const selected = item.value === menuItem
        const disabled = disabledItems.includes(item.value)
        return (
            <li
                key={item.value}
                onClick={() => !disabled && setMenuItem(item.value)}
                className={cn(styles.modalMenuItem, {
                    [styles.selectedMenuItem]: selected,
                    [styles.disabledMenuItem]: disabled,
                })}
                title={disabled ? 'Доступно только при редактировании существующей записи' : undefined}
            >
                {item.icon()}
                {item.name}
                {item && item?.error && <i className={styles.error}><MdOutlineError /></i>}
            </li>
        )
    }


    return (
        <Modal
            classNames={{ modal: styles.modalMain }}
            closeOnOverlayClick={false}
            closeOnEsc={false}
            showCloseIcon={false}
            center
            animationDuration={1}
            {...props}
        >
            <div className={cn(menuList.length ? styles.modalContent : styles.modalContentQuit, { [styles.compact]: compact })}>

                <div className={styles.modalMenu}>
                    <ul>{menuList.map((item) => renderLi(item))}</ul>
                </div>
                {children}
            </div>
        </Modal>
    )
}
